import React from 'react';

import { View } from 'react-native';

import { PencilIcon } from 'assets/images';

import ProfileLogo from '../ProfileLogo';
import styles from './styles';

type Props = {
    iconId?: string;
    isEditable?: boolean;
    withPlaceholder?: boolean;
};

function ProfileEditLogo({
    iconId = 'default',
    isEditable,
    withPlaceholder = false,
}: Props) {
    return (
        <View style={styles.container}>
            <ProfileLogo
                iconId={iconId}
                withPlaceholder={withPlaceholder || iconId === 'default'}
            />
            {isEditable && (
                <>
                    <View style={styles.logoOverlay} />
                    <PencilIcon style={styles.logoIcon} />
                </>
            )}
        </View>
    );
}

export default ProfileEditLogo;
